var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallRate3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15z",
    fill: "#FBBF24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.567 11.629c0 1.294-.735 2.344-1.64 2.344-.907 0-1.641-1.05-1.641-2.344 0-1.294.734-2.344 1.64-2.344.906 0 1.64 1.05 1.64 2.344zM21.004 11.629c0 1.294-.734 2.344-1.64 2.344-.906 0-1.64-1.05-1.64-2.344 0-1.294.734-2.344 1.64-2.344.906 0 1.64 1.05 1.64 2.344z",
    fill: "#111827"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.572 20.535c0-.69.56-1.25 1.25-1.25h9.687a1.25 1.25 0 110 2.5H9.822c-.69 0-1.25-.56-1.25-1.25z",
    fill: "#111827"
  })));
}
export default SvgSmallRate3;